import BackIcon from '../icons/BackIcon'
import IconContainer from '../icons/IconContainer'
import Container from '../basic-components/Container'
import Content from '../basic-components/Content'
import { Header } from '../basic-components/HeaderFooter'
import HeaderTitle from '../basic-components/HeaderTitle'
import Menu from '../basic-components/Menu'

const helpItems = [
  {
    text: 'iPhone Settings',
    value: 'https://youtu.be/YpPj5WWivwg',
  }, {
    text: 'Android Settings',
    value: 'https://youtu.be/-znzTD62QGw',
  }
]

export default function HelpPage({ onBackClick }) {
  const itemClickHandler = (e) => {
    const choice = e.target.parentNode.innerText.trim();
    // using first one
    const chosenItem = helpItems.filter(item => item.text === choice)[0];
    //console.log(chosenItem);
    window.location.href = chosenItem.value;
  }

  return (
    <Container>
      <Header>
      <IconContainer>
        <BackIcon onClick={onBackClick}/>
      </IconContainer>
        <HeaderTitle><strong>Trouble Videos</strong></HeaderTitle>
        <IconContainer>
        </IconContainer>
      </Header>
      <Content>
      <Menu
        items={helpItems}
        onItemClick={itemClickHandler}
      />
      </Content>
    </Container>

  );
}
